import ProductThumbnails from "./product-thumbnails"
import { useRef, useState } from "react"
import MainImageCarousel from "./main-image-carousel"
import { useIsMobile } from "@/hooks/use-is-mobile"

interface props {
  gallery: any[]
  videoUrl: string
  productName: string
}

const Index = (props: props) => {
  const { gallery, videoUrl, productName } = props

  const [activeIndex, setActiveIndex] = useState(0)
  const { isMobile } = useIsMobile()
  const prevPropsRef = useRef({ gallery })

  if (prevPropsRef.current.gallery !== gallery) {
    const shouldResetIndex =
      prevPropsRef.current.gallery.length !== gallery.length ||
      prevPropsRef.current.gallery.some(
        (x, i) => x?.image !== gallery[i]?.image
      )

    prevPropsRef.current.gallery = gallery

    if (shouldResetIndex) {
      setActiveIndex(0)
    }
  }

  return (
    <div className="items-start lg_flex lg_gap-[24px]">
      {isMobile ? null : (
        <ProductThumbnails
          images={gallery}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          videoUrl={videoUrl}
          productName={productName}
        />
      )}
      <MainImageCarousel
        images={gallery}
        videoUrl={videoUrl}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        productName={productName}
      />
    </div>
  )
}

export default Index
